import EnforceMFA from './EnforceMFA';

export default EnforceMFA;
